import * as Yup from 'yup';
import { getProductShape } from 'validators/Common/baseVehicleTypeValidator';

export class UpdateVehicleTypeValidator {
  public get schema() {
    return Yup.object().shape({
      ...getProductShape()
    });
  }
}
